import { stadiumApi, porticoApi } from './axios'
import { decamelizeKeys } from 'humps'
import { ORG_NAME } from './env'

export const fetchVenues = () => porticoApi.get(`/devices/venues`)

export const fetchAttendants = (venueUuid) => stadiumApi.get('/operator/attendants', { 
  params: {
    venue_uuid: venueUuid,
    organization_name: ORG_NAME
  }
})

export const fetchAttendantSettings = (venueUuid, params) => stadiumApi.get('/api/v1/attendant_settings', { params: { ...params, venue_uuid: venueUuid } })

export const fetchCustomers = (venueUuid) => stadiumApi.get('/operator/customers',
  {
    params: {
      venue_uuid: venueUuid,
    }
  }
)

export const fetchCustomerOrderingPreferences = (customerId, venueUuid) =>
  stadiumApi.get(`/operator/customer/${customerId}/ordering_preferences`,
  {
    params: {
      venue_uuid: venueUuid
    }
  }
)

export const fetchAllCustomerOrderingPreferences = (venueUuid) =>
  stadiumApi.get('/operator/customer/ordering_preferences',
  {
    params: {
      type: 'Customer::StandPreference',
      venue_uuid: venueUuid
    }
  }
)

export const fetchAllCustomerOrderingPreferencesByEventId = (salesEventId) =>
  stadiumApi.get('/operator/customer/ordering_preferences', { params : {
    sales_event_id: salesEventId,
    type: 'Customer::StandPreference'
  }})

export const fetchAllCustomerOrderingPreferencesByEventIdByCustomerId = (salesEventId, customerId) =>
  stadiumApi.get('/operator/customer/ordering_preferences', { params : {
    sales_event_id: salesEventId,
    customer_id: customerId
  }})

export const fetchCustomerPayments = (customerId) => stadiumApi.get(`/operator/customer/${customerId}/payments`)

export const setCustomerPaymentAuthorizedSignatory = data => {
  let params = decamelizeKeys({ data })
  params.data = { customer_payments: [ params.data ] }

  return stadiumApi.put(`/operator/customer/payments`, params)
}

export const fetchSalesEvents = venueUuid => stadiumApi.get('/operator/sales_events', { params: { venue_uuid: venueUuid } })

export const fetchSalesEventTypes = () => stadiumApi.get('/operator/sales_event_types')

export const fetchEmployeeRoles = (venueUuid, employeeId, salesEventId) => stadiumApi.get('/operator/employee_roles',
  {
    params: {
      employee_uuid: employeeId,
      sales_event_id: salesEventId,
      venue_uuid: venueUuid
    }
  }
)

export const fetchPreOrders = (venueUuid, salesEventId) => {
  return stadiumApi.get('/pos/orders', { params: { venue_uuid: venueUuid, sales_event_id: salesEventId } })
}

export const fetchRevenueCenters = (venueUuid) => stadiumApi.get('pos/stands', { params: {
    organization_name: ORG_NAME,
    venue_uuid: venueUuid
  }
})

export const createAttendant = (venueUuid, data) => {
  data.venue_uuid = venueUuid
  let params = decamelizeKeys({ data })
  params.data = {attendants: [ params.data ]}

  return stadiumApi.post('/operator/attendants', params)
}

export const createAttendantSetting = (venueUuid, data) => {
  data.organization_name = ORG_NAME
  data.venue_uuid = venueUuid
  let params = decamelizeKeys({ data })
  params.data = { app_device_configurations: [ params.data ] }

  return stadiumApi.post('/api/v1/app_device_configurations', params)
}

export const createCustomerOrderingPreference = (customerId, data) => {
  let params = decamelizeKeys({ data })
  params.data = {ordering_preferences: params.data}

  return stadiumApi.post(`/operator/customer/ordering_preferences`, params)
}

export const createEmployeeRole = (data) => {
  let params = decamelizeKeys({ data })
  params.data = { employee_roles: [ params.data ] }

  return stadiumApi.post(`/operator/employee_roles`, params)
}

export const removeCustomerOrderingPreference = (preferenceUuid) => stadiumApi.delete(`/operator/customer/ordering_preferences/${preferenceUuid}`)

export const removeAttendant = (uuid) => stadiumApi.delete(`/operator/attendants/${uuid}`)

export const removeAttendantSetting = (uuid) => stadiumApi.delete(`/api/v1/app_device_configurations/${uuid}`)

export const updateAttendantSetting = (data) => {
  let params = decamelizeKeys({ data })
  params.data = { app_device_configurations: [ params.data ] }

  return stadiumApi.put('/api/v1/app_device_configurations/', params)
}

export const updateAttendant = (data) => {
  let params = decamelizeKeys({ data })
  params.data = { attendants: [ params.data ] }

  return stadiumApi.put('/operator/attendants/', params)
}

export const updateSalesEvent = (data) => {
  let params = decamelizeKeys({ data })
  params.data = { sales_events: [ params.data ] }

  return stadiumApi.put('/operator/sales_events', params)
}

export const updateEmployeeRole = (data) => {
  let params = decamelizeKeys({ data })
  params.data = { employee_roles: [ params.data ] }

  return stadiumApi.put('/operator/sales_events', params)
}

export const deleteEmployeeRole = (externalRefId) => {
  return stadiumApi.delete(`/operator/employee_roles/${externalRefId}`)
}

export const createOrderCapture = (salesEventId) => {
  return stadiumApi.post(`/external/orders/batch_capture.json?sales_event_uuid=${salesEventId}`)
}

export const fetchOrderCaptureStatus = (salesEventId) => {
  return stadiumApi.get(`/external/orders/batch_capture/status.json?sales_event_uuid=${salesEventId}`)
}

export default {
  createAttendant,
  createAttendantSetting,
  createCustomerOrderingPreference,
  createEmployeeRole,
  deleteEmployeeRole,
  fetchAllCustomerOrderingPreferences,
  fetchAllCustomerOrderingPreferencesByEventId,
  fetchAttendants,
  fetchAttendantSettings,
  fetchCustomers,
  fetchCustomerOrderingPreferences,
  fetchCustomerPayments,
  fetchAllCustomerOrderingPreferencesByEventIdByCustomerId,
  fetchEmployeeRoles,
  fetchRevenueCenters,
  fetchPreOrders,
  fetchSalesEvents,
  fetchSalesEventTypes,
  fetchVenues,
  removeAttendant,
  removeAttendantSetting,
  removeCustomerOrderingPreference,
  setCustomerPaymentAuthorizedSignatory,
  updateAttendant,
  updateAttendantSetting,
  updateSalesEvent,
  createOrderCapture,
  fetchOrderCaptureStatus
}
